// Action Types
export const GET_PDF_STATISTICS = 'queue-pdf/GET_PDF_STATISTICS';
export const GET_PDF_STATISTICS_SUCCESS = 'queue-pdf/GET_PDF_STATISTICS_SUCCESS';

export const REMOVE_QUEUE = 'queue-pdf/REMOVE_QUEUE';
export const REMOVE_QUEUE_SUCCESS = 'queue-pdf/REMOVE_QUEUE_SUCCESS';